// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2nyxo","notes":"Notes_notes__KBlVY"};